import React from 'react';

function ActionCard({ icon, title, desc, onClick }) {
  return (
    <div className="action-card" onClick={onClick}>
      <div className="action-icon">{icon}</div>
      <div className="action-title">{title}</div>
      <div className="action-desc">{desc}</div>
    </div>
  );
}

export default ActionCard;